module.exports = __webpack_public_path__ + "img/join-us-mianshi.f3e62ca3.png";